export function applyFavicon(dataUrl) {
  if (!dataUrl) return;
  document.querySelectorAll("link[rel~='icon'], link[rel='apple-touch-icon']").forEach((l) => l.remove());
  const icon = document.createElement("link");
  icon.rel = "icon";
  icon.href = dataUrl;
  document.head.appendChild(icon);
  const apple = document.createElement("link");
  apple.rel = "apple-touch-icon";
  apple.href = dataUrl;
  document.head.appendChild(apple);
}
